import { render, staticRenderFns } from "./SensorsGuidelines.vue?vue&type=template&id=09ba8090&scoped=true"
import script from "./SensorsGuidelines.vue?vue&type=script&lang=js"
export * from "./SensorsGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba8090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ba8090')) {
      api.createRecord('09ba8090', component.options)
    } else {
      api.reload('09ba8090', component.options)
    }
    module.hot.accept("./SensorsGuidelines.vue?vue&type=template&id=09ba8090&scoped=true", function () {
      api.rerender('09ba8090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/BuildingsSpaces/SensorsGuidelines.vue"
export default component.exports